import {
  imageModal,
  modalClose,
  modalBackBtn,
  thumbnailStrip,
  modalImage,
  zoomInBtn,
  zoomOutBtn,
  resetZoomBtn,
  zoomLevel,
  modalContent,
  prevBtn,
  nextBtn,
  galleryPrevBtn,
  galleryNextBtn,
  imageCounter,
  MIN_SCALE,
  MAX_SCALE,
  SCALE_STEP,
  navOptions,
  dropdownMenu,
  countryToggle,
  countryMenu,
  countryOptions,
  menuToggle,
  getCountryNameFromCode,
  AppState
} from './globals.js';
import {
  loadFlyers,
  loadDeals,
  loadWishlist,
  loadHomepageDealImages
} from './data.js';

// ============================================
// IMAGE MODAL FUNCTIONS
// ============================================

export function showFlyerGallery(merchantName) {
  AppState.currentMerchant = merchantName;
  AppState.modalMode = "gallery";

  const merchantFlyers = AppState.merchantFlyersMap.get(merchantName) || [];
  const flyersWithImages = merchantFlyers
    .filter((f) => f.FlyerImageUrl)
    .sort((a, b) => (a.PageNo || 0) - (b.PageNo || 0));

  if (flyersWithImages.length === 0) {
    alert("No flyer images available for this merchant.");
    return;
  }

  thumbnailStrip.innerHTML = "";
  flyersWithImages.forEach((flyer, index) => {
    const img = document.createElement("img");
    img.src = flyer.FlyerImageUrl;
    img.alt = `Page ${flyer.PageNo || index + 1}`;
    img.className = "thumbnail-img";
    img.dataset.url = flyer.FlyerImageUrl;
    img.addEventListener("click", (e) => {
      e.stopPropagation();
      openImageModal(flyer.FlyerImageUrl, merchantName);
    });
    thumbnailStrip.appendChild(img);
  });

  thumbnailStrip.style.display = "flex";
  document.querySelector(".image-container").style.display = "none";
  document.querySelector(".controls-panel").style.display = "none";
  prevBtn.style.display = "none";
  nextBtn.style.display = "none";
  modalBackBtn.style.display = "none";

  galleryPrevBtn.style.display = "flex";
  galleryNextBtn.style.display = "flex";

  imageModal.classList.add("active");
  document.body.style.overflow = "hidden";
}

export function openImageModal(imageUrl, merchantName) {
  AppState.currentMerchant = merchantName;
  AppState.modalMode = "single";
  resetZoom();

  thumbnailStrip.style.display = "none";
  document.querySelector(".image-container").style.display = "flex";
  document.querySelector(".controls-panel").style.display = "flex";
  modalBackBtn.style.display = "block";

  galleryPrevBtn.style.display = "none";
  galleryNextBtn.style.display = "none";

  const merchantFlyers = AppState.merchantFlyersMap.get(merchantName) || [];
  const flyersWithImages = merchantFlyers
    .filter((f) => f.FlyerImageUrl)
    .sort((a, b) => (a.PageNo || 0) - (b.PageNo || 0));
  AppState.flyerImages = flyersWithImages.map((f) => f.FlyerImageUrl);

  AppState.currentImageIndex = AppState.flyerImages.indexOf(imageUrl);
  if (AppState.currentImageIndex === -1) AppState.currentImageIndex = 0;

  updateModalImage();
  imageModal.classList.add("active");
  document.body.style.overflow = "hidden";
}

export function closeImageModal() {
  imageModal.classList.remove("active");
  document.body.style.overflow = "";

  thumbnailStrip.style.display = "none";
  thumbnailStrip.innerHTML = "";
  document.querySelector(".image-container").style.display = "flex";
  document.querySelector(".controls-panel").style.display = "flex";
  modalBackBtn.style.display = "none";
  prevBtn.style.display = "flex";
  nextBtn.style.display = "flex";

  galleryPrevBtn.style.display = "none";
  galleryNextBtn.style.display = "none";

  AppState.currentMerchant = null;
}

export function updateModalImage() {
  if (
    AppState.flyerImages.length > 0 &&
    AppState.currentImageIndex >= 0 &&
    AppState.currentImageIndex < AppState.flyerImages.length
  ) {
    modalImage.src = AppState.flyerImages[AppState.currentImageIndex];
    modalImage.style.transform = `scale(${AppState.currentScale})`;
    zoomLevel.textContent = `${Math.round(AppState.currentScale * 100)}%`;
    imageCounter.textContent = `${AppState.currentImageIndex + 1} / ${AppState.flyerImages.length}`;
    prevBtn.style.display = AppState.currentImageIndex > 0 ? "flex" : "none";
    nextBtn.style.display =
      AppState.currentImageIndex < AppState.flyerImages.length - 1 ? "flex" : "none";

    if (AppState.currentImageIndex < AppState.flyerImages.length - 1) {
      const nextImg = new Image();
      nextImg.src = AppState.flyerImages[AppState.currentImageIndex + 1];
    }
  }
}

export function navigateToPrevImage() {
  if (AppState.currentImageIndex > 0) {
    AppState.currentImageIndex--;
    resetZoom();
    updateModalImage();
  }
}

export function navigateToNextImage() {
  if (AppState.currentImageIndex < AppState.flyerImages.length - 1) {
    AppState.currentImageIndex++;
    resetZoom();
    updateModalImage();
  }
}

export function zoomImage(direction) {
  if (direction === "in") {
    AppState.currentScale = Math.min(AppState.currentScale + SCALE_STEP, MAX_SCALE);
  } else if (direction === "out") {
    AppState.currentScale = Math.max(AppState.currentScale - SCALE_STEP, MIN_SCALE);
  }
  modalImage.style.transform = `scale(${AppState.currentScale})`;
  zoomLevel.textContent = `${Math.round(AppState.currentScale * 100)}%`;
}

export function resetZoom() {
  AppState.currentScale = 1;
  if (modalImage) {
    modalImage.style.transform = `scale(${AppState.currentScale})`;
    zoomLevel.textContent = `${Math.round(AppState.currentScale * 100)}%`;
  }
}

// ============================================
// CARD IMAGE FUNCTIONS
// ============================================

export function setupCardImages() {
  const cards = document.querySelectorAll(".card");
  cards.forEach((card) => {
    const imageUrl = card.getAttribute("data-image");
    const merchantName = card.getAttribute("data-merchant");
    const cardImage = card.querySelector(".card-image");

    if (cardImage && imageUrl) {
      cardImage.style.backgroundImage = `url(${imageUrl})`;
      cardImage.style.opacity = "0.7";

      const img = new Image();
      img.src = imageUrl;

      img.onload = () => {
        cardImage.style.opacity = "1";
        cardImage.style.backgroundImage = `url(${imageUrl})`;
      };

      img.onerror = () => {
        cardImage.style.background = `linear-gradient(135deg, rgba(220, 20, 60, 0.1), rgba(220, 20, 60, 0.05))`;
        cardImage.style.display = "flex";
        cardImage.style.alignItems = "center";
        cardImage.style.justifyContent = "center";
        cardImage.innerHTML = `
          <div style="text-align: center; color: #dc143c; opacity: 0.3;">
            <i class="fas fa-image" style="font-size: 3rem; margin-bottom: 10px;"></i>
            <p style="font-size: 0.9rem;">${merchantName}</p>
          </div>
        `;
      };

      if (img.complete) {
        img.onload();
      }
    }

    card.addEventListener("click", () => {
      const merchantName = card.getAttribute("data-merchant");
      if (merchantName) {
        showFlyerGallery(merchantName);
      }
    });
  });
}

export function setupAutoScrollImages() {
  const imageScroll = document.querySelector(".image-scroll");
  if (!imageScroll) return;
  const images = imageScroll.querySelectorAll("img");
  images.forEach((img) => {
    const clone = img.cloneNode(true);
    imageScroll.appendChild(clone);
  });
}

// ============================================
// NAVIGATION FUNCTIONS
// ============================================

export function setupAccountDropdown() {
  menuToggle.addEventListener("click", function (e) {
    e.stopPropagation();
    dropdownMenu.classList.toggle("show");
  });

  document.addEventListener("click", function (event) {
    if (
      !menuToggle.contains(event.target) &&
      !dropdownMenu.contains(event.target)
    ) {
      dropdownMenu.classList.remove("show");
    }
  });
}

export function setupCountryDropdown() {
  countryToggle.addEventListener("click", function (e) {
    e.stopPropagation();
    const isAccountMenuOpen = dropdownMenu.classList.contains("show");
    if (isAccountMenuOpen) dropdownMenu.classList.remove("show");
    countryMenu.classList.toggle("show");
  });

  countryOptions.forEach((option) => {
    option.addEventListener("click", function (e) {
      e.preventDefault();
      const value = this.getAttribute("data-value");

      AppState.selectedCountryCode = value;
      AppState.selectedCountryName = getCountryNameFromCode(value);
      localStorage.setItem("walleto_country", AppState.selectedCountryCode);
      updateCountryButton(value);
      countryMenu.classList.remove("show");

      if (AppState.currentView === "flyers") {
        loadFlyers();
        loadHomepageDealImages();
      } else if (AppState.currentView === "deals") {
        loadDeals();
      } else if (AppState.currentView === "wishlist") {
        loadWishlist();
      }
      // console.log("Country changed to:", AppState.selectedCountryName);
    });
  });

  // --- NEW: Mobile Country Button Click ---
  const mobileCountryBtn = document.getElementById("mobileCountryBtn");
  if (mobileCountryBtn) {
    mobileCountryBtn.addEventListener("click", function (e) {
      e.preventDefault();
      // Instantly swap the country
      const newCode = AppState.selectedCountryCode === "CA" ? "US" : "CA";

      AppState.selectedCountryCode = newCode;
      AppState.selectedCountryName = getCountryNameFromCode(newCode);
      localStorage.setItem("walleto_country", AppState.selectedCountryCode);
      updateCountryButton(newCode);

      // Close mobile menu and reload data
      document.getElementById("mobileMenu").classList.remove("active");

      if (AppState.currentView === "flyers") {
        loadFlyers();
        loadHomepageDealImages();
      } else if (AppState.currentView === "deals") {
        loadDeals();
      } else if (AppState.currentView === "wishlist") {
        loadWishlist();
      }
    });
  }

  document.addEventListener("click", function (e) {
    if (!countryToggle.contains(e.target) && !countryMenu.contains(e.target)) {
      countryMenu.classList.remove("show");
    }
  });
}

export function updateCountryButton(countryCode) {
  const icon = countryToggle.querySelector("i");
  const text = countryToggle.querySelector("span") || document.createElement("span");
  if (!countryToggle.querySelector("span")) {
    countryToggle.innerHTML = "";
    countryToggle.appendChild(icon);
    countryToggle.appendChild(text);
  }
  if (countryCode === "CA") text.textContent = " CA";
  else if (countryCode === "US") text.textContent = " US";

  const mobileCountryText = document.getElementById("mobileCountryText");
  if (mobileCountryText) {
    mobileCountryText.textContent = countryCode === "CA" ? "Canada (CA)" : "United States (US)";
  }
}

export function setupNavigationOptions() {
  navOptions.forEach((option) => {
    option.addEventListener("click", function () {
      const optionText = this.textContent.trim();

      // Reset all options
      navOptions.forEach((opt) => {
        opt.style.background = "rgba(255, 255, 255, 0.7)";
        opt.style.color = "#444";
        opt.style.boxShadow = "none";
      });

      if (optionText.includes("Deals")) {
        this.style.background = "rgba(220, 20, 60, 0.15)";
        this.style.color = "#DC143C";
        this.style.boxShadow = "0 8px 15px rgba(220, 20, 60, 0.15)";
        loadDeals();
      } else if (optionText.includes("Shopping Cart") || optionText.includes("Wishlist")) {
        this.style.background = "rgba(220, 20, 60, 0.15)";
        this.style.color = "#DC143C";
        this.style.boxShadow = "0 8px 15px rgba(220, 20, 60, 0.15)";
        loadWishlist();
      }
    });
  });
}

// ============================================
// ZOOM PREVENTION
// ============================================

export function setupZoomPrevention() {
  document.addEventListener(
    "wheel",
    function (e) {
      if (e.ctrlKey || e.metaKey) e.preventDefault();
    },
    { passive: false },
  );

  document.addEventListener(
    "wheel",
    function (e) {
      if (e.ctrlKey || e.metaKey) {
        const isOnImage = e.target === modalImage;
        if (isOnImage) {
          e.preventDefault();
          if (e.deltaY < 0) zoomImage("in");
          else zoomImage("out");
        }
      }
    },
    { passive: false },
  );

  ["gesturestart", "gesturechange", "gestureend"].forEach((eventType) => {
    document.addEventListener(eventType, function (e) {
      e.preventDefault();
    });
  });
}

// ============================================
// DYNAMIC FLYER MARQUEE WALL (HERO BACKGROUND)
// ============================================

export function setupHeroMarquee() {
  const heroBg = document.querySelector('.hero-bg');
  if (!heroBg) return;

  heroBg.innerHTML = '';
  heroBg.style.backgroundImage = 'none';

  if (!AppState.allFlyers || AppState.allFlyers.length === 0) return;

  // Use only the first 8 cover flyer images (already displayed below)
  const coverUrls = AppState.allFlyers
    .map(f => f.FlyerImageUrl)
    .filter(url => url && url.startsWith("http"))
    .slice(0, 8);

  if (coverUrls.length === 0) return;

  const marqueeContainer = document.createElement('div');
  marqueeContainer.className = 'marquee-container';

  const numTracks = 4;

  for (let i = 0; i < numTracks; i++) {
    const track = document.createElement('div');
    track.className = 'marquee-track';

    // Repeat the same 8 cached images instead of fetching 160 unique ones
    const trackUrls = [...coverUrls, ...coverUrls];

    trackUrls.forEach(url => {
      const img = document.createElement('img');
      img.src = url;
      img.loading = "lazy";
      img.alt = "Flyer Background";
      track.appendChild(img);
    });

    marqueeContainer.appendChild(track);
  }

  heroBg.appendChild(marqueeContainer);
}

// ============================================
// HERO SEARCH BAR TYPEWRITER ANIMATION
// ============================================
const placeholders = [
  "Search for Deals...",
  "Search for Chicken Breast...",
  "Search for Milk...",
  "Search for Eggs...",
  "Search for Pizza...",
  "Search for Olive Oil..."
];

let currentPlaceholderIndex = 0;
let currentCharIndex = 0;
let isDeleting = false;

// Speed settings (in milliseconds)
const typingSpeed = 90;
const deletingSpeed = 50;
const pauseBetweenWords = 2500;

export function typeWriter() {
  const searchInput = document.getElementById("heroSearchInput");
  if (!searchInput) return;

  // Don't animate if the user is actively typing in the box
  if (document.activeElement === searchInput && searchInput.value !== "") {
    return setTimeout(typeWriter, 1000);
  }

  const currentWord = placeholders[currentPlaceholderIndex];

  if (isDeleting) {
    searchInput.setAttribute("placeholder", currentWord.substring(0, currentCharIndex - 1));
    currentCharIndex--;
  } else {
    searchInput.setAttribute("placeholder", currentWord.substring(0, currentCharIndex + 1));
    currentCharIndex++;
  }

  let nextSpeed = isDeleting ? deletingSpeed : typingSpeed;

  // Word is fully typed
  if (!isDeleting && currentCharIndex === currentWord.length) {
    nextSpeed = pauseBetweenWords;
    isDeleting = true;
  }
  // Word is fully deleted
  else if (isDeleting && currentCharIndex === 0) {
    isDeleting = false;
    currentPlaceholderIndex = (currentPlaceholderIndex + 1) % placeholders.length;
    nextSpeed = 500; // Brief pause before typing the next word
  }

  setTimeout(typeWriter, nextSpeed);
}

// ============================================
// UTILITY FUNCTIONS
// ============================================

export function formatMerchantName(merchant) {
  const names = {
    Costco: "Costco",
    FreshCo: "FreshCo",
    Sobeys: "Sobeys",
    Walmart: "Walmart",
    "Food Basics": "Food Basics",
    "Real Canadian Superstore": "Superstore",
    "No Frills": "No Frills",
    Loblaws: "Loblaws",
    Metro: "Metro",
    "Farm Boy": "Farm Boy",
    Longos: "Longo's",
    "Super C": "Super C",
  };
  return names[merchant] || merchant;
}

export function formatDate(dateString) {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch (error) {
    return "N/A";
  }
}

// ============================================
// DOWNLOAD MODAL FUNCTIONALITY
// ============================================
const floatingDownloadBtn = document.getElementById("floatingDownloadBtn");
const downloadModal = document.getElementById("downloadModal");
const downloadModalOverlay = document.getElementById("downloadModalOverlay");
const downloadModalClose = document.getElementById("downloadModalClose");

if (floatingDownloadBtn) {
  floatingDownloadBtn.addEventListener("click", () => {
    downloadModal.classList.add("active");
    downloadModalOverlay.classList.add("active");
    document.body.style.overflow = "hidden"; // Stops page scrolling behind the modal
  });
}

function closeDownloadModal() {
  downloadModal.classList.remove("active");
  downloadModalOverlay.classList.remove("active");
  document.body.style.overflow = "";
}

if (downloadModalClose) {
  downloadModalClose.addEventListener("click", closeDownloadModal);
}

if (downloadModalOverlay) {
  downloadModalOverlay.addEventListener("click", closeDownloadModal);
}

// ============================================
// Mobile Hamburger
// ============================================
document.addEventListener("DOMContentLoaded", () => {
  const hamburgerBtn = document.getElementById("hamburgerBtn");
  const mobileMenu = document.getElementById("mobileMenu");
  const mobileMenuClose = document.getElementById("mobileMenuClose");

  if (hamburgerBtn && mobileMenu && mobileMenuClose) {
    hamburgerBtn.addEventListener("click", () => {
      mobileMenu.classList.add("active");
    });
    mobileMenuClose.addEventListener("click", () => {
      mobileMenu.classList.remove("active");
    });

    const mobileLinks = mobileMenu.querySelectorAll(".mobile-nav-options li");
    mobileLinks.forEach((link) => {
      link.addEventListener("click", function () {
        const optionText = this.textContent.trim();
        if (optionText.includes("Deals")) {
          loadDeals();
        } else if (optionText.includes("Shopping Cart") || optionText.includes("Wishlist")) {
          loadWishlist();
        }
        mobileMenu.classList.remove("active");
      });
    });
  }
});

// ============================================
// HERO SECTION CLICK, SLIDE, & TYPING ANIMATION (PERFECT SYNC)
// ============================================
export function setupHeroAnimation() {
  const heroBrowseFlyerBtn = document.getElementById("heroBrowseFlyerBtn");
  
  // 1. Top Phrases (Action)
  const actionPhrases = [
    "Ask Feelix,",
    "Shop Smart,",
    "Compare Prices,",
    "Discover Deals,",
    "Use Walleto,"
  ];
  let actionIndex = 0;

  // Add click listener if button exists
  if (heroBrowseFlyerBtn) {
    heroBrowseFlyerBtn.addEventListener("click", () => {
      const flyerSection = document.getElementById("mainFlyersSection");
      if (flyerSection) {
        flyerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // 2. Bottom Phrases (Outcome)
  const walletoTaglines = [
    "Stop Overpaying 🛑",
    "Same Product - Lower Prices 🔥",
    "Compare & Save 💰",
    "Same Product - Better Decisions 💡",
    "Save Up to 20% on Groceries 💸",
    "Unlock More Savings ✨",
    "Same Product - Smarter Move 🧠",
    "Experience Smarter Shopping 🛒",
    "Savings Made Simple ⚡"
  ];
  
  let tagIndex = 0;
  let tagCharIndex = 0;
  let isTagDeleting = false;
  const heroTypingText = document.getElementById("heroTypingText");

  function animateHeroTaglines() {
    if (!heroTypingText) return;
    const currentText = walletoTaglines[tagIndex];

    // Typing and Deleting logic
    if (isTagDeleting) {
      heroTypingText.textContent = currentText.substring(0, tagCharIndex - 1);
      tagCharIndex--;
    } else {
      heroTypingText.textContent = currentText.substring(0, tagCharIndex + 1);
      tagCharIndex++;
    }

    // Speeds: 80ms for typing, 40ms for fast deleting
    let speed = isTagDeleting ? 40 : 80;

    // When word finishes typing -> Pause for 2.5s before deleting
    if (!isTagDeleting && tagCharIndex === currentText.length) {
      speed = 2500; 
      isTagDeleting = true;
    } 
    // When word finishes deleting -> SYNC THE TOP TEXT CHANGE
    else if (isTagDeleting && tagCharIndex === 0) {
      isTagDeleting = false;
      tagIndex = (tagIndex + 1) % walletoTaglines.length; 
      
      // --- TRIGGER TOP TEXT SLIDE ANIMATION ---
      if (heroBrowseFlyerBtn) {
        heroBrowseFlyerBtn.classList.add("slide-out"); // Slide up and fade out
        
        setTimeout(() => {
          // Change the top text while it is invisible
          actionIndex = (actionIndex + 1) % actionPhrases.length;
          heroBrowseFlyerBtn.textContent = actionPhrases[actionIndex];

          // Teleport to bottom prep state, then slide in smoothly
          heroBrowseFlyerBtn.classList.remove("slide-out");
          heroBrowseFlyerBtn.classList.add("slide-in-prep");
          
          void heroBrowseFlyerBtn.offsetWidth; // Force CSS repaint
          
          heroBrowseFlyerBtn.classList.remove("slide-in-prep"); // Slide back to normal
        }, 400); // 400ms matches your CSS slide-out transition time
      }

      // Pause for 600ms before typing the next word to give the top text time to slide
      speed = 600; 
    }
    
    setTimeout(animateHeroTaglines, speed);
  }
  
  // Delay the animation start slightly after page load
  setTimeout(animateHeroTaglines, 1000);
}

// ============================================
// FOOTER ANIMATION OBSERVER
// ============================================
document.addEventListener("DOMContentLoaded", () => {
  const footer = document.querySelector(".premium-footer");
  if (!footer) return; 

  const brand = document.querySelector(".footer-brand");
  const links = document.querySelector(".footer-links");
  const social = document.querySelector(".footer-social");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          footer.classList.add("show");
          setTimeout(() => brand?.classList.add("show"), 200);
          setTimeout(() => links?.classList.add("show"), 400);
          setTimeout(() => social?.classList.add("show"), 600);
        } else {
          footer.classList.remove("show");
          brand?.classList.remove("show");
          links?.classList.remove("show");
          social?.classList.remove("show");
        }
      });
    },
    { threshold: 0.25 },
  );

  observer.observe(footer);
});